import React, { useState } from "react";
import BgComponent from "../Components/BgComponent";
import Logo from "../../../assets/image/logo/logo.png";
import CustomFormLabel from "../../../components/common/CustomFormLabel";
import RHFTextField from "../../../components/controls/RHFTextField";
import { Link, useNavigate } from "react-router-dom";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { IconButton } from "@mui/material";
import { useUser } from "../../../context/UserContext";
import { object, string } from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import Supabase from "../../../backend/client";
import { errorToaster, successToaster } from "../../../util/toaster";
import MaskLoader from "../../../components/MaskLoader";

const ForgetPassword = () => {
  const user = useUser();
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();

  const schema = object({
    email: string()
      .email("Please enter valid email address")
      .required()
      .label("Email")
      .nullable(),
  });

  const {
    control,
    formState: { errors },
    handleSubmit,
    setValue,
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  });

  React.useEffect(() => {
    document.title = "TRADEFOLIO - Forget Password";
    if (user?.user?.id) {
      navigate("/");
    }
  }, []);

  const onSubmit = async (data) => {
    setLoader(true);
    const host = window.location.protocol + "//" + window.location.host;
    console.log(`${host}/auth/profile/update`);

    const { data: user, error } = await Supabase.from("profiles")
      .select("*")
      .eq("email", data?.email);
    if (error) {
      errorToaster(error?.message);
      reset({
        email: "",
      });
      setLoader(false);
      return;
    }

    if (!user?.length) {
      errorToaster("User is not registered Please create account.");
      reset({
        email: "",
      });
      setLoader(false);
      return;
    }

    const result = await Supabase.auth.resetPasswordForEmail(data?.email, {
      redirectTo: `${host}/auth/profile/update`,
    });
    if (result?.error) {
      errorToaster(result?.error?.message);
      reset({
        email: "",
      });
      setLoader(false);
      return;
    }
    reset({
      email: "",
    });
    setLoader(false);
    successToaster(
      "Reset Password link has been sent on your registered mailid."
    );
  };

  return loader ? (
    <MaskLoader />
  ) : (
    <>
      <div className="flex flex-col min-h-[100vh] w-full">
        <div className="lg:hidden xs:mb-0">
          <IconButton
            onClick={() => navigate(-1)}
            sx={{
              margin: 3,
              color: "#000",
              position: "absolute",
              zIndex: 999,
            }}>
            <ArrowBackIcon />
          </IconButton>
        </div>

        <div className="flex flex-row w-full h-[100vh] flex-1">
          <div className="lg:flex flex-[0.40] xs:hidden">
            <BgComponent bgImg="bg-reset-bg">
              <div className="bg-[#0061fc] mix-blend-multiply absolute w-full h-[100%]"></div>

              <p className="text-white xl:text-[50px] lg:text-[40px] font-bold absolute top-40 xl:left-28 lg:left-16">
                Use Expert Tools <br />
                Without Coding Skills.
              </p>
            </BgComponent>
          </div>
          <div className="flex md:flex-[0.60] xs:flex-[0.80] flex-col lg:max-w-[550px] mx-auto xs:pt-[80px] md:pt-[40px] justify-center">
            <a href="/">
              <img src={Logo} className="relative xs:w-[120px] md:w-[170px]" />
            </a>
            <div className="xs:py-4 md:py-12 xl:px-0">
              <p className="xs:text-[22px] md:text-[35px] font-bold font-sans">
                Forgot password?
              </p>
              <p className="text-[#7A86A1] text-xs md:text-sm">
                Enter the email address you used when you joined and we’ll{" "}
                <br />
                send you instructions to reset your password.
              </p>
              <div className="grid grid-cols-1 lg:grid-cols-2 xs:gap-[10px] md:gap-5 xs:pt-[15px] md:pt-10">
                <div>
                  <CustomFormLabel htmlFor="email">Your email</CustomFormLabel>
                  <RHFTextField
                    name="email"
                    id="email"
                    type="email"
                    fullWidth
                    placeholder="Tonynguyen@example.com"
                    className="mt-[10px] px-[10px] xs:py-[5px] md:py-[10px] w-full text-[12px] text-[#7A86A1] border-[1px] border-[#7A86A1] rounded-lg "
                    isControlled={true}
                    control={control}
                    errorObj={errors}
                  />
                </div>
                <div></div>
                <div>
                  <button
                    className="w-full bg-[#0061FC] text-white  font-semibold xs:p-1 md:p-3 rounded-lg xs:text-[12px] md:text-[14px]"
                    onClick={handleSubmit(onSubmit)}>
                    Submit
                  </button>
                </div>
                <div></div>
                <div>
                  <Link
                    to="/auth/login"
                    className="text-[#0061FC]  font-semibold xs:text-[12px] md:text-[14px]">
                    <KeyboardBackspaceIcon /> Back to sign in
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="flex justify-between py-[20px] md:px-20 xs:px-4  text-[#000000] w-full border-t-[1px]">
          <div className="opacity-50 text-[10px] font-sans">
            &copy;2023 TRADEFOLIO Inc. All Rights Reserved
          </div>
          <div className="opacity-50 text-[10px] font-sans  ">
            <Link to="/privacy">
              <u>Privacy Policy</u>
            </Link>{" "}
            /{" "}
            <Link to="/terms">
              <u>User agreement</u>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgetPassword;
